function initializeJBTrustedSliders() {
  document
    .querySelectorAll('[data-jb-trusted-slider]:not([data-jb-slider-ready])')
    .forEach((slider) => {
      slider.dataset.jbSliderReady = 'true';

      const track = slider.querySelector('[data-jb-trusted-track]');
      const previousButton = slider.querySelector('[data-jb-trusted-prev]');
      const nextButton = slider.querySelector('[data-jb-trusted-next]');

      if (!track || !previousButton || !nextButton) return;

      const getScrollAmount = () => {
        const firstSlide = track.querySelector('.jb-trusted-slider__slide');

        if (!firstSlide) return track.clientWidth;

        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return firstSlide.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maximumScroll = track.scrollWidth - track.clientWidth;

        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;

        const sliderIsNeeded = maximumScroll > 5;
        previousButton.hidden = !sliderIsNeeded;
        nextButton.hidden = !sliderIsNeeded;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      updateButtons();
    });
}

document.addEventListener('DOMContentLoaded', initializeJBTrustedSliders);

let jbTrustedAutoSlide;

function startJBTrustedAutoSlide() {
  const slider = document.querySelector('.jb-trusted-slider__track');

  if (!slider) return;

  clearInterval(jbTrustedAutoSlide);

  jbTrustedAutoSlide = setInterval(() => {
    const slides = slider.querySelectorAll(
      '.jb-trusted-slider__slide'
    );

    if (slides.length <= 1) return;

    const firstSlide = slides[0];

    const slideWidth =
      firstSlide.offsetWidth +
      parseFloat(getComputedStyle(slider).gap || 0);

    const maxScroll =
      slider.scrollWidth - slider.clientWidth;

    /*
     * If we reached the end,
     * smoothly return to the beginning.
     */
    if (slider.scrollLeft >= maxScroll - 5) {
      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else {
      slider.scrollBy({
        left: slideWidth,
        behavior: 'smooth'
      });
    }
  }, 4000);
}

startJBTrustedAutoSlide();

document.addEventListener('shopify:section:load', initializeJBTrustedSliders);